<template>
  <div
    v-if="isVisualEditor"
    class="editor-annotation absolute -top-3 z-40 ml-4 bg-transparent"
  >
    <span
      class="rounded-md border-2 border-dashed border-cyan-500 bg-slate-50/70 px-2 py-0.5 text-xs text-cyan-800"
    >
      <slot />
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const isVisualEditor = computed(() => {
  return import.meta.env.VITE_IS_EDITOR
})
</script>
